import React, { useEffect } from 'react'

import ReactDOM from 'react-dom'
import {
  ApolloProvider,
  ApolloClient,
  InMemoryCache,
  ApolloLink,
  concat,
  createHttpLink,
  Observable,
  split
} from '@apollo/client'
import { getMainDefinition } from '@apollo/client/utilities'
import { WebSocketLink } from '@apollo/client/link/ws'
import 'firebase/messaging'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import ConfigurableValues from './config/constants'
import { ConfigurationProvider } from './context/Configuration'
import App from './app'
import { RestProvider } from './context/Restaurant'
import { ThemeProvider, StyledEngineProvider } from '@mui/material'
import theme from './utils/theme'
import './assets/css/switch.css'

function Main() {
  const {
    SENTRY_DSN,
    GOOGLE_MAPS_KEY,
    SERVER_URL,
    WS_SERVER_URL
  } = ConfigurableValues()
  console.log('GOOGLE_MAPS_KEY', GOOGLE_MAPS_KEY)
  useEffect(() => {
    Sentry.init({
      dsn: SENTRY_DSN,
      integrations: [new Integrations.BrowserTracing()],
      tracesSampleRate: 0.1
    })
  }, [])

  const cache = new InMemoryCache()
  const httpLink = createHttpLink({
    uri: `${SERVER_URL}/graphql`
  })
  const wsLink = new WebSocketLink({
    uri: `${WS_SERVER_URL}/graphql`,
    options: {
      reconnect: true
    }
  })
  const request = async operation => {
    const data = localStorage.getItem('user-borku')

    let token = null
    if (data) {
      token = JSON.parse(data).token
    }
    operation.setContext({
      headers: {
        authorization: token ? `Bearer ${token}` : ''
      }
    })
  }

  const requestLink = new ApolloLink(
    (operation, forward) =>
      new Observable(observer => {
        let handle
        Promise.resolve(operation)
          .then(oper => request(oper))
          .then(() => {
            handle = forward(operation).subscribe({
              next: observer.next.bind(observer),
              error: observer.error.bind(observer),
              complete: observer.complete.bind(observer)
            })
          })
          .catch(observer.error.bind(observer))

        return () => {
          if (handle) handle.unsubscribe()
        }
      })
  )
  const terminatingLink = split(({ query }) => {
    const { kind, operation } = getMainDefinition(query)
    return kind === 'OperationDefinition' && operation === 'subscription'
  }, wsLink)

  const client = new ApolloClient({
    link: concat(ApolloLink.from([terminatingLink, requestLink]), httpLink),
    cache,
    resolvers: {},
    connectToDevTools: true
  })

  return (
    <ApolloProvider client={client}>
      <ConfigurationProvider>
        {/* <LoadScript
          id="script-loader"
          googleMapsApiKey={GOOGLE_MAPS_KEY}
          libraries={[
            'drawing',
            'places',
            'geometry',
            'localContext',
            'visualization'
          ]}> */}

        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <RestProvider>
              {/* <GoogleMapsLoader> */}
              <App />
              {/* </GoogleMapsLoader> */}
            </RestProvider>
          </ThemeProvider>
        </StyledEngineProvider>

        {/* </LoadScript> */}
      </ConfigurationProvider>
    </ApolloProvider>
  )
}

// No admin number field accepts negatives (prices, fees, quantities, limits),
// so block the minus sign app-wide instead of patching every input. Add
// data-allow-negative to an input to opt out.
const isGuardedNumber = el =>
  el &&
  el.tagName === 'INPUT' &&
  el.type === 'number' &&
  !el.hasAttribute('data-allow-negative')
document.addEventListener(
  'keydown',
  e => {
    if (isGuardedNumber(e.target) && ['-', 'e', 'E', '+'].includes(e.key)) {
      e.preventDefault()
    }
  },
  true
)
document.addEventListener(
  'paste',
  e => {
    if (!isGuardedNumber(e.target)) return
    const text = (e.clipboardData || window.clipboardData).getData('text')
    if (/[-eE+]/.test(text)) e.preventDefault()
  },
  true
)
// Stop the spinner arrows from stepping below zero
document.addEventListener(
  'focusin',
  e => {
    if (isGuardedNumber(e.target) && !e.target.hasAttribute('min')) {
      e.target.setAttribute('min', '0')
    }
  },
  true
)

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(<Main />, document.getElementById('root'))
